import * as React from "react";
const SvgFavoriteFill20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "black",
        viewBox: "0 0 20 20"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M13.163 6.396 10 .34 6.837 6.396.1 7.533l4.781 4.88-1 6.759L10 16.132l6.119 3.04-1-6.759 4.781-4.88-6.737-1.137Z",
      clipRule: "evenodd"
    })
  );
export default SvgFavoriteFill20Px;
